import validate from "/Users/bridgecode/workspace/insabank/insabank_frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/Users/bridgecode/workspace/insabank/insabank_frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "login-required": () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/middleware/loginRequired.js"),
  "mobile-check": () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/middleware/mobileCheck.js"),
  "only-admin": () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/middleware/onlyAdmin.js")
}